export { MockTickstarTransactionProvider } from './transaction-provider';
export { MockTickstarSmpProvider } from './smp-provider';
export { SEED_PARTICIPANTS, SEED_TRANSACTIONS } from './seed';

import { MockTickstarTransactionProvider } from './transaction-provider';
import { MockTickstarSmpProvider } from './smp-provider';
import { SEED_PARTICIPANTS, SEED_TRANSACTIONS } from './seed';
import type { ProviderRegion } from '@solara/peppol-provider';

/**
 * Convenience: returns a pair of mock providers pre-seeded with demo data.
 *
 * The customer portal and admin console import this from
 * `@solara/peppol-tickstar/mock` to get a fully working mock backbone with no
 * additional setup.
 */
export function createMockTickstarBundle(region: ProviderRegion = 'EU') {
  const transactions = new MockTickstarTransactionProvider(region, 1200, SEED_TRANSACTIONS);
  const smp = new MockTickstarSmpProvider(region, SEED_PARTICIPANTS);
  return { transactions, smp };
}
